<span class="assistance-provider-chip"
      [ngClass]="{'active': isAssistanceProvider === true, 'inactive': isAssistanceProvider === false}">
  Assistance
</span>
